var form = {
    ids: ["startDate", "endDate", "primaryAge", "spouseAge", "citizenshipCountry"],
    fields: {
        "startDate": {
            $el:"",
            value:"",
            validate:["required","date","notPast"]
        },
        "endDate": {
            $el:"",
            value:"",
            validate:["required","date","notBeforeStartDate"]
        },
        "primaryAge": {
            $el:"",
            value:"",
            validate:["required","numbers","notPrimaryMinorAge"]
        },
        "spouseAge": {
            $el:"",
            value:"",
            validate:["numbers","notMinorAge"]
        },
        "citizenshipCountry": {
            $el:"",
            value:"",
            validate:["required"]
        }
    },
    isFormSubmitted: false,
    queryFields: {
        primaryAge: null,
        spouseAge: null,
        numChildren: '',
        startDate: '',
        endDate: '',
        studyCountry: '',
        residenceCountry:'',
        homeCountry: '',
        citizenshipCountry: '',
        arrivalInUSA: '',
        arrivalTime: '',
        mailingState: '',
        physicalPresenceState: '',
        showSpouseAge: false,
        showNumChildren: false,
        visaStatus:'',
        f1Insurance:'-1',
        section: 'student'
    },
    spinnerOpts: {
        lines: 11 // The number of lines to draw
        , length: 25 // The length of each line
        , width: 6 // The line thickness
        , radius: 21 // The radius of the inner circle
        , scale: 0.35 // Scales overall size of the spinner
        , corners: 1 // Corner roundness (0..1)
        , color: '#fff' // #rgb or #rrggbb or array of colors
        , opacity: 0.45 // Opacity of the lines
        , rotate: 0 // The rotation offset
        , direction: 1 // 1: clockwise, -1: counterclockwise
        , speed: 1.4 // Rounds per second
        , trail: 60 // Afterglow percentage
        , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
        , zIndex: 2e9 // The z-index (defaults to 2000000000)
        , className: 'spinner' // The CSS class to assign to the spinner
        , top: '50%' // Top position relative to parent
        , left: '50%' // Left position relative to parent
        , shadow: false // Whether to render a shadow
        , hwaccel: true // Whether to use hardware acceleration
        , position: 'absolute' // Element positioning
    },
    init: function(){
        var formIds = this.ids;
        var formFields = this.fields;
        for(var i = 0, formlength = formIds.length ; i < formlength ; i++) {
            formFields[formIds[i]].$el = document.querySelector("#"+formIds[i]);
        }

        var $formBtn = document.querySelector(".quote-form-button");
        $formBtn.addEventListener("click", this.onSubmit);

        if($(".c-Widget__horizontal").length){
            this.spinnerOpts.scale = 0.25;
        }

        //initialize Validation fields
        this.validation(true);

        //initialize pikADay
        var $calendars = document.querySelectorAll(".icon-calendar");
        for(var i = 0, itemLength = $calendars.length ; i < itemLength ; i++) {
            new Pikaday({
                field: $calendars[i],
                onSelect: function(date) {
                    this._o.field.previousElementSibling.value = date.getMonth()+1 + "/" + date.getDate() + "/"  +date.getFullYear();
                }
            });
        }

        let removeChat = setInterval(() => {
            const chatFrame = document.getElementById('fc_frame')
            if(chatFrame) {
                chatFrame.style.display = 'none';
                clearInterval(removeChat);
            };
        }, 100);
    },
    validate: {
        fields:{},
        invalid: false,
        submitted: false
    },
    validation: function(initialize) {
        var fields = this.fields;
        var _this = this;

        //creating fields and validation parameters.
        if(initialize) {
            for(var key in fields) {
                this.validate.fields[key]= {
                        invalid:false
                };
                var valiKeys = fields[key].validate.filter(function(item){
                    _this.validate.fields[key][item] = true;
                });
            }
        } else {
            var fields = this.validate.fields;

            //Traversing into each validation field items and setting the boolean flag.
            var parentInvalid = false;
            for(var field in fields) {
                var flagPerField = false;
                for(var key in fields[field]) {
                    this.fields[field].value = this.fields[field].$el.value;
                    var fieldValue = this.fields[field].$el.value;
                    if(key == "required") {
                        if(fieldValue && fieldValue.trim() != '') {
                            fields[field][key] = true;
                        } else {
                            fields[field][key] = false;
                        }
                    }
                    if(key == "numbers" && fieldValue && fieldValue.trim() != '') {
                        fields[field][key] = /^\d+$/.test(fieldValue) && parseInt(fieldValue) > 0;
                    } else if(key == "numbers") {
                        fields[field][key] = true;
                    }
                    if(key == "date" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                            fields[field][key] = commonFunctions.dateValidation(this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    } else if(key == "date") {
                        fields[field][key] = true;
                    }
                    if(fields[field]["date"] && key == "notPast" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                            fields[field][key] = commonFunctions.dateNotInPast(this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    }
                    if(key == "notBeforeStartDate" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                            fields[field][key] = commonFunctions.notBeforeThisDate(this.fields["startDate"].$el.value, this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    }
                    if(key == "notPrimaryMinorAge" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '' && this.fields['spouseAge'].$el.value) {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                            fields[field][key] = commonFunctions.notPrimaryMinorAge(this.fields["primaryAge"].$el.value, this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    }
                        else if(key == "notPrimaryMinorAge"){
                        fields[field][key] = true;
                    }
                    if(key == "notMinorAge" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '' && fields['primaryAge']['notPrimaryMinorAge']) {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '' ) {
                            fields[field][key] = commonFunctions.notMinorAge(this.fields["spouseAge"].$el.value, this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    }
                        else if(key == "notMinorAge"){
                        fields[field][key] = true;
                    }
                    var $errorEl = document.querySelector("." + field +  ".error [val-" + key + "]");
                    if(!fields[field][key] && key !== 'invalid') {
                        if($errorEl) $errorEl.style.display = "block";
                        flagPerField = true;
                    } else {
                        if($errorEl) $errorEl.style.display = "none";
                    }
                }
                fields[field].invalid = flagPerField ? true : false;
                if(fields[field].invalid) {
                    parentInvalid = true;
                }
            }
            this.validate.fields = fields;
            this.validate["invalid"] = parentInvalid;
        }
    },
    onSubmit: function(e) {
        var _this = form;
        _this.validation();
        var isAlreadySubmitted = false;

        if(_this.isFormSubmitted == false) {
            _this.ids.forEach((item)=>{
                if(item != "citizenshipCountry") {
                    $("#"+ item).on('keypress', (e)=>{
                        $(".error." + e.currentTarget.id).css("display", "none");
                    });
                    $("#"+ item).on('blur', (e)=>{
                        $(".error." + e.currentTarget.id).css("display", "block");
                        _this.validation();
                    });
                }
            });
            $("#citizenshipCountry").on("change", ()=>{
                _this.validation();
            });
        }

        _this.isFormSubmitted = true;


        var $serverErrorElm = document.querySelector(".server-error.error");
        $serverErrorElm.style.display = "none";
        if(!_this.validate.invalid) {
            _this.queryFields = {
                primaryAge: _this.fields.primaryAge.value,
                spouseAge: _this.fields.spouseAge.value || -1,
                numChildren: 0,
                startDate: commonFunctions.changeDateToEn(_this.fields.startDate.value, 2, 'en'),
                endDate: commonFunctions.changeDateToEn(_this.fields.endDate.value, 2, 'en'),
                studyCountry: 'USA',
                residenceCountry:'',
                homeCountry: 'IND',
                citizenshipCountry: _this.fields.citizenshipCountry.value,
                arrivalInUSA: '0',
                arrivalTime: '',
                mailingState: 'OutsideUSA',
                physicalPresenceState: '',
                showSpouseAge: false,
                showNumChildren: false,
                visaStatus:'F1',
                f1Insurance:'-1',
                section: 'student'
            };

            //ajax using jQuery
            var urlStudent = '/api/compare/student-medical';

            var clientURL = window.location.href;
            var getIndex = clientURL.indexOf("?");
            var query = "";
            if (getIndex > -1) {
                query = clientURL.substring(getIndex, clientURL.length);
            }
            if (query && query != "") {
                urlStudent += query;
            }

            var xhr = new XMLHttpRequest();
            xhr.open("POST", urlStudent, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json'); 
            xhr.send(JSON.stringify(_this.queryFields));
            document.querySelector("button.quote-form-button .btn-text").style.display = "none";
                document.querySelector("button.quote-form-button #spinner").style.display = "inline-block";

            //initialize spinner
            var target = document.getElementById('spinner');
            var spinner = new Spinner(_this.spinnerOpts).spin(target);

            xhr.onreadystatechange = function() {
                document.querySelector("button.quote-form-button #spinner").style.display = "none";
                document.querySelector("button.quote-form-button .btn-text").style.display = "inline-block";
                if((this.readyState==3 || this.readyState==4) && this.status==200 && !isAlreadySubmitted) {
                    isAlreadySubmitted = true;
                    var responseBody = JSON.parse(xhr.responseText);
                    if(responseBody.status==="error") {
                        $serverErrorElm.innerHTML = "<h4 class='c-Server-errors__heading'>Error!</h4>";
                        if(responseBody.data.hasOwnProperty("allErrorMessages") || responseBody.data.hasOwnProperty("globalErrors")) {
                            var errorMessages = responseBody.data.allErrorMessages || responseBody.data.globalErrors;
                            $serverErrorElm.style.display="block";
                            for(var i = 0, errorLength = errorMessages.length; i < errorLength; i++) {
                                var $p=document.createElement("p");
                                var message = errorMessages[i].hasOwnProperty("message") ? errorMessages[i].message :  errorMessages[i];
                                $p.innerHTML = message;
                                $serverErrorElm.append($p);
                            }
                        } else if (responseBody.data.hasOwnProperty("noPlansFound") && responseBody.data.noPlansFound) {
                            $serverErrorElm.style.display = "block";
                            $serverErrorElm.innerHTML = "<p>No Plans Found!</p>";
                        }
                    } else if(responseBody.status==="success") {
                        $serverErrorElm.style.display="none";
                        window.open(responseBody.data.redirectToBN, "_blank");
                    }
                }
            }
        }
    },
    formatDate: function(e) {
        var thisDate = e.currentTarget.value;
        if(!isNaN(thisDate) && (thisDate.length == 6 || thisDate.length == 8)) {
            var dateArray = thisDate.match(/^(\d{2})(\d{2})(\d{2,4})$/);
            var year = dateArray[3].length==2 ? "20" + dateArray[3] : dateArray[3];
            var month = dateArray[1];
            var day = dateArray[2];
            e.currentTarget.value = month + "/" + day + "/" + year
        }
    }
};

form.init();

var commonFunctions = {
    dateValidation: function(val) {
        var flag = true;
        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
        var year;

        if(val) {
            var dateArray = val.split("-");
            var yearLength;

            if(Array.isArray(dateArray)) {
                yearLength = dateArray[0] ? dateArray[0].length : '';
            }

            if(dateArray.length == 3 && yearLength === 4) {
                var month;
                var day;

                month = parseInt(Number(dateArray[1]));
                day = parseInt(Number(dateArray[2]));
                year = Number(dateArray[0]);

                // Adjust for leap years
                if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) monthLength[1] = 29;

                if(month > 0 && month <= 12 && day > 0 && day <= monthLength[month - 1]) flag = true;
                else flag = false;

                if(flag && isNaN(year)) flag = false;

                if(year < 1000 || month == 0 || month > 12) return false;

            } else flag = false;

        }
        return flag;
    },
    dateNotInPast: function(date) {
        const dateTmp = date;
        date = this.changeDateToEn(date, 2, 'en');
        var isPast = false;
        var today = new Date();
        if(this.dateValidation(dateTmp)) {
            var secDate = new Date(date);
            if(secDate != "Invalid Date") {
                isPast = secDate.setHours(0,0,0) < today.setHours(0,0,0);
                if( (secDate.getDate() == today.getDate()) &&
                    (secDate.getMonth() == today.getMonth()) &&
                    (secDate.getFullYear() == today.getFullYear())
                ) {
                    isPast = false
                }
            } else {
                isPast = false;
            }
        }else {
            isPast = false;
        }

        return !isPast;
    },
    notPrimaryMinorAge: function(primAge, spouAge) {
        //primAge Being the primary age
        //spouAge being the spouse age
        var isPast = false;       
        if(primAge && spouAge && spouAge != ''){
            if(primAge < 18) {
                isPast = true;       
            } else{
                isPast = false;
            }
        }
        return !isPast;
    },
    notMinorAge: function(primAge, spouAge) {
        //primAge Being the primary age
        //spouAge being the spouse age
        var isSpouseMinor = false;       
        if(primAge && spouAge && spouAge != ''){
            if(spouAge !== -1 && spouAge < 18) {
                isSpouseMinor = true;
            
            } else{
                isSpouseMinor = false;
            }
        }
        return !isSpouseMinor;
    },
    notBeforeThisDate: function(dateOne, dateTwo) {
        //dateOne Being the Start Date
        //dateTwo being the endDate
        const dateOneTmp = dateOne;
        const dateTwoTmp = dateTwo;
        dateOne = this.changeDateToEn(dateOne, 2, 'en');
        dateTwo = this.changeDateToEn(dateTwo, 2, 'en');
        var isPast = false;
        var startDate = new Date(dateOne);
        if(this.dateValidation(dateOneTmp) && this.dateValidation(dateTwoTmp)) {
            var endDate = new Date(dateTwo);
            if(endDate != "Invalid Date" && startDate != "Invalid Date") {
                isPast = endDate.setHours(0,0,0) < startDate.setHours(0,0,0);
            } else {
                isPast = false;
            }
        }else {
            isPast = false;
        }

        return !isPast;
    },
    /**
     * IF a given date string is in EN and it needs to be converted to zh/es or viceversa use this function.
     * 
     * @param {String} formattedDate | Date in any lang format en: MM/DD/YYYY es: DD/MM/YYYY zh: YYYY-MM-DD
     * @param {Number} langId | en: 1 es: 3 zh: 2
     * @param {String} language | in what language the given date has to be formated en/es/zh
     */
    changeDateToEn: function (formattedDate, langId, language='en') {
        let dateParts;
        let year;
        let month;
        let day;
      
        if (langId === 1) { // english
          dateParts = formattedDate.split('/');
          month = dateParts[0];
          day = dateParts[1];
          year = dateParts[2];
        } else if(langId === 2) { // chinese
          dateParts = formattedDate.split('-');
          year = dateParts[0];
          month = dateParts[1];
          day = dateParts[2];
        } else if (langId === 3) { // spanish
          dateParts = formattedDate.split('/');
          day = dateParts[0];
          month = dateParts[1];
          year = dateParts[2];
        }
      
        switch(language) {
          case 'zh': return `${year}-${month}-${day}` // chinese
          case 'es': return `${day}/${month}/${year}` // spanish
          default: return `${month}/${day}/${year}` // english
        }
    }
}

function formatChat() {
    const chatFrameStyles = [
        ['height', '100%!important'],
        ['width', '100%!important'],
        ['minHeight', '100px!important'],
        ['maxHeight', '100vh!important'],
        ['right', '0!important'],
        ['bottom', '0!important'],
        ['overflow', 'hidden'],
    ]

    const chatFrame = document.getElementById('fc_frame');
    chatFrameStyles.forEach( x => chatFrame.style[x[0]] = x[1]);
}
